import { render } from "./textMore.vue?vue&type=template&id=1289740f&scoped=true"
import script from "./textMore.vue?vue&type=script&lang=js"
export * from "./textMore.vue?vue&type=script&lang=js"

import "./textMore.vue?vue&type=style&index=0&id=1289740f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1289740f"]])

export default __exports__